import React, { useContext, useEffect, useState } from 'react';
import WelcomeScreen from '../components/ua-brand-sgm/welcome-screen';
import styles from '../components/lm-d-s/index.module.scss';
import { ScreensContext } from '../contexts/screensContext';
import ErrorPage500 from '../components/ua-brand-sgm/error-page-500';
import ErrorPage404 from '../components/ua-brand-sgm/error-page-404';
import CompanyInfoScreen from '../components/ua-brand-sgm/company-info-screen';
import FaqScreen from '../components/ua-brand-sgm/faq-screen';
import WelcomeAgeVerificationScreen from '../components/ua-brand-sgm/welcome-age-verification-screen';
import CookieManagementScreen from '../components/ua-brand-sgm/cookie-management-screen';
import FaceCaptureScreen from '../components/ua-brand-sgm/face-capture-screen';
import FormScreen from '../components/ua-brand-sgm/form-screen';
import YoungAgeScreen from '../components/ua-brand-sgm/young-age-screen';
import WelcomeFormScreen from '../components/ua-brand-sgm/welcome-form-screen';
import OtpScreen from '../components/ua-brand-sgm/otp-screen';
import AlreadyRegistered from '../components/ua-brand-sgm/already-registered';
import SuccessRegistered from '../components/ua-brand-sgm/success-registered';
import GeoresctrictionScreen from '../components/ua-brand-sgm/georesctriction-screen';
import ErrorPage503 from '../components/ua-brand-sgm/error-page-503';
import ErrorPage from '../components/ua-brand-sgm/errror-page';
import AttemptsExhausted from '../components/ua-brand-sgm/attempts-exhausted';
import NotRealFaceScreen from '../components/ua-brand-sgm/not-real-face-screen';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import sgmService from '../services/sgmService';
import ErrorComponent from '../components/ua-brand-sgm/error-component';

const UABrandSgm = () => {
  const [formData, setFormData] = useState({});
  const utm_campaign = sessionStorage.getItem('utm_campaign');
  const [screenNumber, setScreenNumber] = useState(!utm_campaign ? 14 : 1);
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(true);
  const [isLoadCountry, setIsLoadCountry] = useState(false);
  const [isSgmError, setIsSgmError] = useState(false);
  const telegramLink = `https://t.me/pmu_support_bot?start=ScnPck-${utm_campaign}`;

  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screenNumber]);

  useEffect(() => {
    init(`${sessionStorage.getItem('isQrCode')}`);
  }, [init]);

  useEffect(() => {
    const sgmToken = sessionStorage.getItem('utm_token');
    if (sgmToken) {
      sgmService.validateQrCode(sgmToken).catch((err) => {
        console.error(err);
        setIsSgmError(true);
      });
    }
  }, []);

  useEffect(() => {
    fetch('https://ipapi.co/json/')
      .then((res) => res.json())
      .then((data) => {
        setIsLoadCountry(true);
        setScreenNumber(
          data.country_name?.toLowerCase() === 'ukraine'
            ? !utm_campaign
              ? 14
              : 1
            : 13
        );
      })
      .catch((err) => console.error(err));
  }, []);

  const getScreen = (number, cb) => {
    switch (number) {
      case 1: {
        return (
          <WelcomeScreen
            isVisibleModal={isVisibleModal}
            setIsVisibleModal={setIsVisibleModal}
            setScreenNumber={setScreenNumber}
            handleNextScreen={() => setScreenNumber(5)}
            telegramLink={telegramLink}
          />
        );
      }
      case 2: {
        return (
          <CompanyInfoScreen handleBackButtonClick={() => setScreenNumber(1)} />
        );
      }
      case 3: {
        return (
          <FaqScreen
            setScreenNumber={setScreenNumber}
            handleBackButtonClick={() => setScreenNumber(1)}
          />
        );
      }
      case 4: {
        return <CookieManagementScreen setScreenNumber={setScreenNumber} />;
      }
      case 5: {
        return (
          <WelcomeAgeVerificationScreen
            setScreenNumber={setScreenNumber}
            handleBackButtonClick={() => setScreenNumber(1)}
            handleNextVerificationScreen={() => setScreenNumber(6)}
          />
        );
      }
      case 6: {
        return <FaceCaptureScreen setScreenNumber={setScreenNumber} />;
      }
      case 7: {
        return <YoungAgeScreen backButtonClick={() => setScreenNumber(5)} />;
      }
      case 8: {
        return (
          <WelcomeFormScreen
            setScreenNumber={setScreenNumber}
            handleNextScreen={() => {
              sendEvent('registration');
              setScreenNumber(9);
            }}
            handleSkipScreen={() => {
              sendEvent('skip_registration');
              window.location.href = `https://yourjourney.com.ua/${utm_campaign}`;
            }}
            telegramLink={telegramLink}
          />
        );
      }
      case 9: {
        return (
          <FormScreen
            utm_campaign={utm_campaign}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(8)}
            telegramLink={telegramLink}
            setFormData={(data) => setFormData(data)}
            formData={formData}
          />
        );
      }
      case 10: {
        return (
          <OtpScreen
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
            handleChangePhoneNumber={() => setScreenNumber(9)}
            successSendOtp={() => {
              sendEvent('passed_authorization');
              setScreenNumber(12);
            }}
            attemptsExhaustedChangeScreen={() => setScreenNumber(15)}
          />
        );
      }
      case 11: {
        return (
          <AlreadyRegistered
            telegramLink={telegramLink}
            setScreenNumber={setScreenNumber}
            handleNextButtonClick={() => {
              window.location.href = `https://yourjourney.com.ua/${utm_campaign}`;
            }}
            utm_campaign={utm_campaign}
          />
        );
      }
      case 12: {
        return (
          <SuccessRegistered
            telegramLink={telegramLink}
            setScreenNumber={setScreenNumber}
            handleNextButtonClick={() => {
              window.location.href = `https://yourjourney.com.ua/${utm_campaign}`;
            }}
          />
        );
      }
      case 13: {
        return (
          <GeoresctrictionScreen
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
          />
        );
      }
      case 14: {
        return (
          <ErrorPage
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
          />
        );
      }
      case 15: {
        return (
          <AttemptsExhausted
            setScreenNumber={setScreenNumber}
            checkPhoneNumber={() => setScreenNumber(9)}
            telegramLink={telegramLink}
          />
        );
      }
      case 16: {
        return (
          <NotRealFaceScreen
            setScreenNumber={setScreenNumber}
            handleRepeatButtonClick={() => setScreenNumber(6)}
          />
        );
      }
      case 500: {
        return <ErrorPage500 setScreenNumber={cb} />;
      }
      case 503: {
        return <ErrorPage503 setScreenNumber={cb} />;
      }
      case 404: {
        return <ErrorPage404 setScreenNumber={cb} />;
      }
      default: {
        return <ErrorPage404 setScreenNumber={cb} />;
      }
    }
  };
  return (
    (isSgmError || isLoadCountry) && (
      <div className={styles.pageContainer} id="ua-brand">
        <div className={styles.contentContainer}>
          <ScreensContext.Provider
            value={{
              endSessionType,
              setEndSessionType,
              isDisplayedAll,
              setIsDisplayedAll
            }}
          >
            {isSgmError ? (
              <ErrorComponent />
            ) : (
              getScreen(screenNumber, setScreenNumber)
            )}
          </ScreensContext.Provider>
        </div>
      </div>
    )
  );
};

export default UABrandSgm;
